import request from '@onefootprint/request';
import type { AuthHeaders } from '@/hooks/use-session';

const errorWorkflows = async (authHeaders: AuthHeaders, ids: string[]) => {
  const response = await request<Record<string, never>>({
    method: 'POST',
    url: '/private/protected/error_workflows',
    headers: authHeaders,
    data: { ids },
  });
  return response.data;
};

export default errorWorkflows;
